import { render, staticRenderFns } from "./InclusionRisk.vue?vue&type=template&id=ca36a2f2&scoped=true&"
import script from "./InclusionRisk.vue?vue&type=script&lang=js&"
export * from "./InclusionRisk.vue?vue&type=script&lang=js&"
import style0 from "./InclusionRisk.vue?vue&type=style&index=0&id=ca36a2f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca36a2f2",
  null
  
)

export default component.exports